// src/components/TradersNavbar.jsx
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding-left: 240px;

  @media only screen and (max-width: 768px) {
    padding-left: 10px;
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;

  @media only screen and (max-width: 768px) {
    gap: 12px;
  }
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;
  &:hover {
    color: teal;
  }
`;

export default function TradersNavbar() {
  const navigate = useNavigate();

  return (
    <Container>
      <Wrapper>
        <Left>
          <MenuItem onClick={() => navigate("/")}>🏠 Home</MenuItem>
          <MenuItem onClick={() => navigate("/traders")}>
            📘 Traders Home
          </MenuItem>
        </Left>
      </Wrapper>
    </Container>
  );
}
